import React from "react";
import { VendorAlert } from "./InternalNotesResult";

interface Props {
  vendorAlerts: VendorAlert;
}

const InternalNotesVendorAlert = ({ vendorAlerts }: Props) => {
  const {
    vendorAlertMessage,
    vendorAlertMessageEndDate,
    vendorAlertMessageStartDate,
  } = vendorAlerts;
  return (
    <div className="vendor-alert" data-testid="vendorAlertMessage">
      <strong className="vendor-alert__title">
        Alert Message
        <br />
        From {vendorAlertMessageStartDate} EST
        <br />
        Until {vendorAlertMessageEndDate} EST
      </strong>
      <p
        className="vendor-alert__message"
        dangerouslySetInnerHTML={{ __html: vendorAlertMessage }}
      />
    </div>
  );
};

export default InternalNotesVendorAlert;
